class HintEmptySelectLevelValidator {
    /**
     * Constructs a new HintEmptySelectLevelValidator instance.
     * @param {Object} model - The model object to validate.
     * @param {Object} $injector - The AngularJS injector service.
     */
    constructor(model, $injector) {
        this.model = model;
        this.$injector = $injector;
        this._translate = null;
        this._messageTranslateString = 'CMS.FACTORIES.MODELS.VALIDATORS.EMPTY.HINT-SELECT-LEVEL';
        this._message = null;
        this._forced_check = false;
    }

    /**
     * Lazy-loads the $translate service from the injector.
     * @returns {Object} The $translate service.
     */
    get $translate() {
        if (!this._translate) {
            this._translate = this.$injector.get('$translate');
        }
        return this._translate;
    }

    /**
     * Validates the model based on certain conditions.
     * @param {Object} from - The source object triggering the validation.
     * @returns {Object} The validation result.
     */
    validate(from) {
        let result = {};
        let error = false;

        // Check if the model's object type is 'hint'
        if (this.model.getObjectType && this.model.getObjectType() === 'hint') {
            let preferences = this.model.getPreferences ? this.model.getPreferences() : this.model.preferences;
            if (!preferences.level) {
                error = true;
            }
        }

        result = {
            'onSheetBlur':      false,
            'onlyBanner':       false,
            'validator':        this.getValidatorName(),
            'modelUUID':        this.model.getUUID(),
            'error':            error,
            'status':           error ? 'DANGER' : 'SUCCESS',
            'message':          this.getErrorMessage(),
            'message_template': false,
            'callbacks':        [
                'validationDisplayObjectHeader-' + this.model.getUUID()
            ]
        };

        return result;
    }

    /**
     * Gets the error message for the validation.
     * @returns {string} The translated error message.
     */
    getErrorMessage() {
        let questionHeadline = this.model.getQuestionHeadline ? this.model.getQuestionHeadline() : '';
        this._message = this.$translate.instant(this._messageTranslateString, {
            s: questionHeadline
        });

        return this._message;
    }

    /**
     * Gets the forced check flag.
     * @returns {boolean} The forced check flag.
     */
    get forcedCheck() {
        return this._forced_check;
    }

    /**
     * Gets the name of the validator.
     * @returns {string} The name of the validator.
     */
    getValidatorName() {
        return 'HintEmptySelectLevelValidator';
    }
}

export default HintEmptySelectLevelValidator;